import "./CommonQuestions.module.css";
import Header from "@/reusable_sections/Header";
import CommonInquiries from "./sections/CommonInquiries";
import Footer from "@/reusable_sections/Footer";
export default function CommonQuestionsPage() {
  return <div>
      <Header />
      <CommonInquiries />
      <Footer />
    </div>;
}